import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import circleslogosmall from '../../../assets/brand/circles/circleslogosmall.png'
import { PictureWrapper } from '../../../common/ui/colorBox'
import { formatDateToLocale } from '../../../helpers/date'

export function SupportThreadMessage({ message, author, sentTime }) {
  return (
    <Box
      display='flex'
      flexDirection='row-reverse'
      alignContent='center'
      sx={{ m: 2 }}
    >
      <PictureWrapper
        image={circleslogosmall}
        style={{
          width: 32,
          height: 32,
          marginLeft: '16px',
          marginTop: '10px'
        }}
      />
      <Box display='flex' flexDirection='column' sx={{ maxWidth: '70%' }}>
        <Box
          display='flex'
          alignItems='center'
          sx={{ height: '30px', py: '10px' }}
        >
          <Typography variant='h6'>{author}</Typography>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          sx={{
            p: '8px',
            backgroundColor: '#D9E0E9',
            borderRadius: '10px',
            minHeight: '50px'
          }}
        >
          <Box minWidth={'250px'}>
            <Typography>{message}</Typography>
          </Box>
          <Box display='flex' justifyContent='flex-end'>
            <Typography variant='caption'>
              {formatDateToLocale(sentTime)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

SupportThreadMessage.propTypes = {
  message: PropTypes.string,
  author: PropTypes.string,
  sentTime: PropTypes.string
}
